import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {withStyles} from '@material-ui/core/styles';
import {emphasize, fade} from '@material-ui/core/styles/colorManipulator';
import Chip from '@material-ui/core/Chip';

import leaflet from 'leaflet';

import ViewStack from './ViewStack';

const styles = (theme) => {
    return {
        dummy: {
            backgroundColor: theme.palette.common.transparent,
            zIndex: -100,
        },
        chip: {
            float: 'left',
            marginRight: 16,
        },
        chipRoot: {
            color: theme.palette.primary.displayText,
            backgroundColor: theme.palette.primary.main,
        },
        chipClickable: {
            '&:hover, &:focus': {
                backgroundColor: emphasize(theme.palette.primary.main, 0.17),
            },
            '&:active': {
                backgroundColor: theme.palette.primary.main,
            },
        },
        chipDeletable: {
            '&:focus': {
                backgroundColor: theme.palette.primary.main,
            },
        },
        chipDeleteIcon: {
            color: fade(theme.palette.primary.contrastText, 0.26),
            '&:hover': {
                color: fade(fade(theme.palette.primary.contrastText, 0.26), 0.4),
            },
        }
    };
}

class ChipControl extends Component {
    constructor(props) {
        super(props);

        this._refMap = {
            dummy: React.createRef(),
        };
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        const nextUid = nextProps.viewStack.peek().uid;

        const result = (this._uid !== nextUid);

        this._uid = nextUid;

        return result;
    }

    render = () => {
        const view = this.props.viewStack.peek();

        this._uid = view.uid;

        const {classes} = this.props;

        return (
            <div className={this.props.className}>
                <div
                    className={classes.dummy}
                    ref={this._refMap.dummy}
                    tabIndex={-1}
                />
                {this.props.viewStack.iterate(this._renderChip)}
            </div>
        );
    }

    _renderChip = (data, index, arr) => {
        const {classes} = this.props;

        const nestedClasses = {
            root: classes.chipRoot,
            clickable: classes.chipClickable,
            deletable: classes.chipDeletable,
            deleteIcon: classes.chipDeleteIcon,
        };

        if (index === (arr.length - 1)) {
            return (
                <Chip
                    className={classes.chip}
                    classes={nestedClasses}
                    key={data.idKey}
                    label={data.name}
                    onClick={this._handleClick}
                    onDelete={() => { this._handleDelete(index); }}
                />
            );
        } else {
            return (
                <Chip
                    className={classes.chip}
                    classes={nestedClasses}
                    key={data.idKey}
                    label={data.name}
                    onDelete={() => { this._handleDelete(index); }}
                />
            );
        }
    }

    _handleClick = () => {
        const view = this.props.viewStack.peek();

        this._refMap.dummy.current.focus();

        if (this.props.map.getZoom() >= view.zoom.min && view.validBounds()) {
            this.props.map.fitBounds(view.region.bounds);
        }

        if (this.props.onClick) {
            this.props.onClick();
        }
    }

    _handleDelete = (index) => {
        this.props.viewStack.popFrom(index + 1);

        if (this.props.onDelete) {
            this.props.onDelete();
        }
    }
}

ChipControl.propTypes = {
    viewStack: PropTypes.instanceOf(ViewStack).isRequired,
    map: PropTypes.instanceOf(leaflet.Map).isRequired,
    onClick: PropTypes.func,
    onDelete: PropTypes.func,
}

export default withStyles(styles)(ChipControl);
